<template>
  <section class="mb-24 lg:mb-36">
    <div class="container">
      <div class="grid grid-cols-6 gap-6 lg:gap-8 xl:gap-10">
        <div class="order-first col-span-6">
          <div class="grid gap-10 overflow-clip rounded-3xl bg-white p-10 lg:grid-cols-3">
            <div class="text-center">
              <div class="as-h4 mb-4">
                Bel ons
              </div>
              <UiButton
                type="secondary"
                label="0318-261133"
                to="tel:0318-261133"
                icon="mdi:phone-outline"
                class="lg:w-full"
              />
            </div>
            <div class="text-center">
              <div class="as-h4 mb-4">
                Stuur een e-mail
              </div>
              <UiButton
                type="secondary"
                label="info@nextrecruitment.nl"
                to="mailto:info@nextrecruitment.nl"
                icon="mdi:envelope-outline"
                class="lg:w-full"
              />
            </div>
            <div class="text-center">
              <div class="as-h4 mb-4">
                Adres
              </div>
              <UiButton
                type="secondary"
                label="Max Planckstraat 2 - 6716 BE Ede"
                target="_blank"
                rel="noopener noreferrer"
                to="https://www.google.com/maps/place/Ede/@52.0309102,5.6263029,15z/data=!4m2!3m1!1s0x0:0x324b762a68689018?sa=X&ved=2ahUKEwjwwLLetsGDAxUF0QIHHesZBWwQ_BJ6BAg5EAA"
                icon="mdi:map-marker-outline"
                class="lg:w-full"
              />
            </div>
          </div>
        </div>
        <div class="col-span-6 max-lg:order-2 lg:col-span-2">
          <RecruiterTile
            class="bg-white"
            :recruiter="recruiter"
          />
        </div>
        <div class="col-span-6 rounded-3xl bg-white p-10 max-lg:order-1 lg:col-span-4">
          <h2 class="as-h3 mb-4">
            Heb je vragen? Vul het formulier in.
          </h2>
          <SofieForm :form-id="1" />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import {useRandomRecruiterQuery} from '~/graphql/graphql';

definePageMeta({
  middleware: ['sofie-page'],
  header: {
    transparent: true,
  },
});

const {result} = useRandomRecruiterQuery();
const recruiter = computed(() => result.value?.randomRecruiter ?? []);
</script>
